import { Dayjs } from 'dayjs';
import { Post_Claim } from '../../../lib/types.ts';

export const DIRECT_LINK_STATE_VERSION = '20231010.1254';

export interface DirectLinkState {
  version: string;
  expires: Dayjs;
  uuid?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  birthday?: string;
  payment_method?: string;
  reservation_accepted: boolean | null;
  rules_accepted: boolean | null;
  policy_accepted: boolean | null;
  claim_body?: Post_Claim;
  unauthorized_error: null | true;
  update_user_error?: string;
  payment_error?: string;
  reservation_error?: string;
  reservation_expired: boolean | null;
  opt_in_accepted: number;
  /** ACH bank account last 4 digits — set when Plaid link succeeds */
  ach_bank_last4?: string;
  /** ACH bank name — set when Plaid link succeeds */
  ach_bank_name?: string;
  /** Incidental card PM ID — stored separately so ACH remains the primary claim method */
  incidental_card_id?: string;
}
